import { configurationForToken } from "../CommonConstants";
import apiClient from "./apiClient";

const addAlert = (alert, vehicleId, token) => {
  const config = configurationForToken(token);
  return apiClient.post(`/admin/alert/custom/vehicle/${vehicleId}/create`, alert, config);
};

const updateAlert = (alert, alertId, token) => {
  const config = configurationForToken(token);
  return apiClient.put(`/admin/alert/custom/${alertId}`, alert, config);
};

const deleteAlert = (alertId, token) => {
  const config = configurationForToken(token);
  return apiClient.delete(`/admin/alert/custom/${alertId}`, config);
};

const allAlerts = (token) => {
  const config = configurationForToken(token);
  return apiClient.get("/admin/alert/custom/all", config);
};

const allVehicleAlerts = (vehicleId, token) => {
  const config = configurationForToken(token);
  return apiClient.get(`/admin/alert/custom/vehicle/${vehicleId}/all`, config);
};

export default {
  addAlert,
  updateAlert,
  deleteAlert,
  allAlerts,
  allVehicleAlerts
};



// WEBPACK FOOTER //
// ./src/Services/AlertMaintenanceAlerts.js